import React, { useState } from 'react';
import KPISet from '../components/KPISet';
import Flow from './Flow';
import List from './List';
import { Tabs, Tab, TabPanel, TabList } from '@mui/joy';
import JSONPretty from 'react-json-pretty';
import Filters from '../components/Filters';

const dataProviderName = 'administrations/commissiondeal';

const Default = () => {
    const [tabValue, setTabValue] = useState(0);
    const defaultFilters = { items: [] };

    return <>
        <KPISet dataProviderName={dataProviderName} filters={defaultFilters} />
        <Tabs value={tabValue} onChange={(e, newValue) => setTabValue(newValue)} sx={{background:'transparent'}} className="mtska-content-tab-wrapper">
            <TabList className="mtska-content-tab-list">
                <Tab className="mtska-content-tab">List</Tab>
                <Tab className="mtska-content-tab">Flow</Tab>
            </TabList>
            <TabPanel value={0} sx={{padding:'10px 0'}} className="mtska-content-tab-panel">
                <List filters={defaultFilters} />
            </TabPanel>
            <TabPanel value={1} sx={{padding:'10px 0'}} className="mtska-content-tab-panel">
                {/* <Filters dataProviderName={dataProviderName} filters={defaultFilters} /> */}
                <Flow filters={defaultFilters} />
            </TabPanel>
        </Tabs>
    </>

}

export default Default;


